/* @flow */

import * as React from 'react';

import {Popover} from 'shells/popover';
import {Title} from 'shells/typography';
import {CloseButton} from 'shells/button';

import './unlock-error.css';

type Props = {
    title: string,
    info: React.Node,
    onClose: () => void,
    anchor: HTMLElement,
};

export function UnlockError(props: Props) {
    return (
        <Popover anchor={props.anchor} onBlur={props.onClose} location='top'>
            <div styleName='content'>
                <div styleName='top'>
                    <Title>{props.title}</Title>
                    <CloseButton onClick={props.onClose} />
                </div>
                <div styleName='info'>{props.info}</div>
            </div>
        </Popover>
    );
}
